import { tw } from "@careinfo/tailwind";
const data = {
  summary: [
    {
      id: "9ad4372f-6aaa-4f61-a669-6c2eddb858a9",
      title: "Net Profit",
    },
  ],
};

function Table({ data, title, isLoading }) {
  const totalIncome = data?.results?.reduce((sum, item) => {
    return sum + item?.balance;
  }, 0);
  const totalExpenses = data?.results?.reduce((sum, item) => {
    return sum + item?.balance;
  }, 0);

  return (
    <div>
      <h3
        className={tw`text-white bg-primary font-semibold p-2 rounded-t-md`}
        style={{
          boxShadow: "0px 1px 6px 0px #00000026",
        }}
      >
        {title}
      </h3>
      {isLoading
        ? Array.from({ length: 4 }).map((_, index) => (
            <div
              key={index}
              className={tw`h-10 w-full bg-white animate-pulse border border-[#dcdcdc]`}
            ></div>
          ))
        : data?.results?.map((c) => (
            <TableSection key={c.name} data={c} title={title} />
          ))}
      <p
        className={tw`grid grid-cols-4  p-2 border border-[#dcdcdc] bg-gray-200`}
      >
        <span
          className={tw`justify-self-start`}
          style={{
            gridColumn: "1/2",
          }}
        >
          Total {title}
        </span>
        <span
          className={tw`justify-self-center`}
          style={{
            gridColumn: "-1/-2",
          }}
        >
          {title === "Income"
            ? Math.abs(totalIncome ?? 0).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : Math.abs(totalExpenses ?? 0).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
        </span>
      </p>
    </div>
  );
}

function TableSection({ data, title }) {
  return (
    <div>
      <p className={tw`grid grid-cols-4 bg-white  p-2 border border-[#dcdcdc]`}>
        <span
          className={tw`justify-self-start`}
          style={{
            gridColumn: "1/2",
          }}
        >
          {data?.name}
        </span>
        <span
          className={tw`justify-self-center`}
          style={{
            gridColumn: "-1/-2",
          }}
        >
          {title === "Income"
            ? Math.abs(data?.balance).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : Math.abs(data?.balance).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
        </span>
      </p>
      {/* {data?.subCategory?.map((sc) => (
        <SubCategories key={sc.id} data={sc} source={data.category} />
      ))} */}
    </div>
  );
}

const FinancialTable = ({
  profileData,
  lossData,
  isLossDataLoading,
  isProfitDataloading,
}: any) => {
  const totalCredit = profileData?.results.reduce(
    (sum, item) => sum + item.balance,
    0
  );
  const totalDebit = lossData?.results.reduce(
    (sum, item) => sum + item.balance,
    0
  );
  const netProfit = Number(totalCredit - Math.abs(totalDebit)) || 0;
  return (
    <div className={tw``}>
      <div className={tw`space-y-1`}>
        <Table
          data={profileData}
          title={"Income"}
          isLoading={isProfitDataloading}
        />
        <Table
          data={lossData}
          title={"Expenses"}
          isLoading={isLossDataLoading}
        />
      </div>
      <div>
        {data.summary.map((data) => (
          <p
            key={data.id}
            className={tw`grid grid-cols-4 text-stroke  p-2 border border-[#dcdcdc] bg-gray-300`}
          >
            <span
              className={tw`justify-self-start`}
              style={{
                gridColumn: "1/2",
              }}
            >
              {netProfit >= 0 ? "Net Profit" : "Net Loss"}
            </span>
            <span
              className={tw`justify-self-center`}
              style={{
                gridColumn: "-1/-2",
              }}
            >
              {Math.abs(netProfit).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </span>
          </p>
        ))}
      </div>
    </div>
  );
};

export default FinancialTable;
